@if (loggedIn) {
  <div class="holder">
    <div id="overall">
      <div class="overallstat">
        <div class="overallupper">
          @if (strings.artesStrings) {
            <p>{{ strings.artesStrings["ACTIVE"] }}</p>
          }
        </div>
        <div class="overalllower">
          @if (overall) {
            <p id="statactive">{{ overall["1"] || 0 }}</p>
          }
        </div>
      </div>
      <div class="overallstat">
        <div class="overallupper">
          @if (strings.artesStrings) {
            <p>
              {{ strings.artesStrings["EXPIRED"] }}
            </p>
          }
        </div>
        <div class="overalllower">
          @if (overall) {
            <p id="statexpired">{{ overall["2"] || 0 }}</p>
          }
        </div>
      </div>
      <div class="overallstat">
        <div class="overallupper">
          @if (strings.artesStrings) {
            <p>
              {{ strings.artesStrings["SUSPENDED"] }}
            </p>
          }
        </div>
        <div class="overalllower">
          @if (overall) {
            <p id="statsuspended">{{ overall["3"] || 0 }}</p>
          }
        </div>
      </div>
      <div class="overallstat">
        <div class="overallupper">
          @if (strings.artesStrings) {
            <p>
              {{ strings.artesStrings["WITHDRAWN"] }}
            </p>
          }
        </div>
        <div class="overalllower">
          @if (overall) {
            <p id="statwithdrawn">{{ overall["4"] || 0 }}</p>
          }
        </div>
      </div>
      <div class="overallstat" style="border-right: 1px solid black">
        <div class="overallupper">
          @if (strings.artesStrings) {
            <p>{{ strings.artesStrings["LOST"] }}</p>
          }
        </div>
        <div class="overalllower">
          @if (overall) {
            <p id="statlost">{{ overall["5"] || 0 }}</p>
          }
        </div>
      </div>
    </div>
    <div id="statselect">
      <div class="statselectitemtitle">
        @if (strings.artesStrings) {
          <p id="statselecttypeLabel">
            {{ strings.artesStrings["PERIOD_TYPE"] }}
          </p>
        }
      </div>
      <div class="statselectitem">
        <select
          id="periodtype"
          name="periodtypes"
          class="statselectdrop"
          [(ngModel)]="selectedPeriodType"
        (change)="
          calculatePeriodStart(selectedPeriodType, selectedAmount);
          setSelectedPeriodType(selectedPeriodType)
        "
          >
          @for (type of periodTypes; track type) {
            <option [ngValue]="type">
              {{ type.value }}
            </option>
          }
        </select>
      </div>
      <div class="statselectitemtitle">
        @if (strings.artesStrings) {
          <p id="statselectamountLabel">
            {{ strings.artesStrings["PERIOD_AMOUNT"] }}
          </p>
        }
      </div>
      <div class="statselectitem">
        @if (selectedAmount) {
          <select
            id="periodnum"
            name="periodnumber"
            [(ngModel)]="selectedAmount"
            class="statselectdrop"
            (change)="calculatePeriodStart(selectedPeriodType, selectedAmount)"
            >
            @for (value of periods; track value) {
              <option [ngValue]="value">
                {{ value.value }}
              </option>
            }
          </select>
        }
      </div>
      <div class="statselectitemtitle">
        @if (strings.artesStrings) {
          <p id="statselectstartLabel">
            {{ strings.artesStrings["PERIOD_START"] }}
          </p>
        }
      </div>
      <div class="statselectitem">
        <input
          id="statweek"
          [ngModel]="startDate | date: 'yyyy-MM-dd'"
          (ngModelChange)="updateStartDate($event)"
          type="date"
          placeholder="yyyy-mm-dd"
          class="statselectdate"
          />
        </div>
        <div class="statselectitem">
          @if (strings.artesStrings) {
            <button
              id="generatestat"
              class="statselectdate"
              style="margin: 0; line-height: 0%"
        (click)="
          getStatistics(
            dateFormatter.dateToStr(startDate, 'yyyymmdd'),
            selectedPeriodType['index'],
            selectedAmount['value']
          )
        "
              >
              {{ strings.artesStrings["GENERATE"] }}
            </button>
          }
        </div>
      </div>
      <div id="stattablecontainer">
        <table id="stattable" class="maintable">
          <tr>
            @if (strings.artesStrings) {
              <th class="headerRow">
                {{ strings.artesStrings["PERIOD"] }}
              </th>
            }
            @for (
              action of constantsService.constants.actionTypes
              | filterActionType
              ; track
              action) {
              <th
                class="headerRow"
                >
                <span>{{ strings.artesStrings[action["action"]] }}</span>
              </th>
            }
          </tr>
          @for (key of objectKeys(statistics); track key) {
            <tbody>
              @if (objectKeys(statistics).length > 0) {
                <td
                  (click)="getSubStatisticsByPeriod(statistics[key])"
                  >
                  @if (key) {
                    <span>{{ key }}</span>
                  }
                </td>
              }
              @for (
                action of constantsService.constants.actionTypes
                | filterActionType
                ; track
                action) {
                <td
          (click)="
            getSubStatisticsByPeriodAndType(statistics[key][action.action])
          "
                  >
                  @if (action) {
                    <span>{{
                      statistics[key][action.action].length
                    }}</span>
                  }
                </td>
              }
            </tbody>
          }
        </table>
      </div>
      @if (showSubStatistics) {
        <div id="substattablecontainer" #substat>
          <table id="substattable" class="maintable">
            <tr>
              <th (click)="sortTable('date')">{{ strings.artesStrings["DATE"] }}</th>
              <th (click)="sortTable('holderName')">
                {{ strings.artesStrings["PERSON"] }}
              </th>
              <th (click)="sortTable('action')">
                {{ strings.artesStrings["ACTION"] }}
              </th>
              <th (click)="sortTable('userName')">
                {{ strings.artesStrings["USER"] }}
              </th>
              <th (click)="sortTable('comment')">
                {{ strings.artesStrings["COMMENT"] }}
              </th>
              <th></th>
            </tr>
            @for (i of subStatistics; track i) {
              <tbody>
                <tr>
                  <td>{{ dateFormatter.dateToStr(i["date"], "yyyymmdd") }}</td>
                  <td>
                    {{ i["person"]["first_name"] }} {{ i["person"]["last_name"] }}
                  </td>
                  <td>{{ strings.artesStrings[i["action_type"]["action"]] }}</td>
                  <td>{{ i["user"]["first_name"] }} {{ i["user"]["last_name"] }}</td>
                  <td>
                    @if (i['comment'] && !i['data']) {
                      <div>
                        @for (line of split(i['comment'], '\\n'); track line) {
                          <div>
                            @for (entry of split(line, ';'); track entry; let i = $index) {
                              <span>
                                @if (strings.artesStrings[entry]) {
                                  <span
                                    >@if (i == 0) {
                                    <span>{{
                                      strings.artesStrings[entry] | titlecase
                                      }}</span
                                      >
                                    }@if (i > 0) {
                                    <span>{{
                                      strings.artesStrings[entry] | lowercase
                                    }}</span>
                                    }</span
                                    >
                                  }
                                  @if (!strings.artesStrings[entry]) {
                                    <span>{{ entry }}</span>
                                  }
                                </span>
                              }
                            </div>
                          }
                        </div>
                      }
                      @if (i['data'] && !i['comment']) {
                        <div>
                          @for (line of splitArr(i['data']); track line) {
                            <div>
                              {{ strings.artesStrings[line.action] | titlecase }}
                              {{ strings.artesStrings[line.constant] | lowercase }}
                              @if (line.constant === 'ENGINE') {
                                <span>{{
                                  line.object.engine
                                }}</span>
                              }
                              @if (line.constant === 'STATION') {
                                <span
                                  >{{ line.object.code }} {{ line.object.station }}</span
                                  >
                                }
                                @if (line.constant === 'STRETCH') {
                                  <span
                                    >{{ line.object.code }} {{ line.object.stretch }}</span
                                    >
                                  }
                                  @if (line.constant === 'CATEGORY') {
                                    <span>{{
                                      line.object.category
                                    }}</span>
                                  }
                                  @if (
                                    line.constant === 'LANGUAGE' ||
                                    line.constant === 'CERTIFICATE_LANGUAGE'
                                    ) {
                                    <span
                                      >{{ line.object.language }}</span
                                      >
                                    }
                                    @if (
                                      line.constant === 'VALID_FROM' ||
                                      line.constant === 'VALID_TO' ||
                                      line.constant === 'ADDITIONAL_INFORMATION' ||
                                      line.constant === 'CATEGORY_REMARK' ||
                                      line.constant === 'RESTRICTIONS'
                                      ) {
                                      <span
                                        >
                                        {{ line.object }}
                                      </span>
                                    }
                                  </div>
                                }
                              </div>
                            }
                          </td>
                          <td class="btnholder">
                            <button (click)="streamCertificate(i)">
                              {{ strings.artesStrings["CERTIFICATE"] }}
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    }
                  </table>
                </div>
              }
            </div>
          }
